import { persistentAtom } from "@nanostores/persistent";
import { atom } from "nanostores";
export const SIDEBAR_KEY = "sidebar";
export const sidebarMenuExpanded = atom(false);
export const sidebarOpened = persistentAtom(SIDEBAR_KEY, false, {
    encode: JSON.stringify,
    decode: JSON.parse,
});
export const setSidebarMenuExpanded = (value) => {
    sidebarMenuExpanded.set(value);
};
export const setSidebarOpened = (value) => {
    sidebarOpened.set(value);
};
//# sourceMappingURL=sidebarStore.js.map